export default __webpack_public_path__ + "static/new-component-lib-736a4a48b50594a9e863259a463d154e.png";